import { useQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { useXeroIntegration } from 'lib/hooks/useXeroIntegration'
import { JournalPostModeSettings } from './JournalPostModeSettings'
import { LedgerAccountMappingSection } from './LedgerAccountMappingSection'
import { MAPPABLE_LEDGER_ACCOUNTS } from './xeroLedgerAccountMappings.constants'

export const XeroLedgerAccountMappings = () => {
  const flags = useFeatureFlags()
  const { xeroIntegration } = useXeroIntegration()

  const isXeroConnected = Boolean(xeroIntegration?.enabled)
  const shouldShow = flags.useXeroLedgerAccountMappings && isXeroConnected

  const mappingsQuery = useQuery(
    dashboardv99990101Client.getXeroLedgerAccountMappings,
    undefined,
    {
      enabled: shouldShow
    }
  )

  if (!shouldShow) {
    return null
  }

  const mappings = mappingsQuery.data?.items ?? []
  const xeroLedgerAccounts = xeroIntegration?.ledgerAccounts ?? []

  return (
    <>
      <JournalPostModeSettings />
      {MAPPABLE_LEDGER_ACCOUNTS.map(ledgerAccount => (
        <LedgerAccountMappingSection
          key={ledgerAccount}
          mappableLedgerAccount={ledgerAccount}
          mappings={mappings.filter(
            m => m.mappableLedgerAccount === ledgerAccount
          )}
          xeroLedgerAccounts={xeroLedgerAccounts}
          isLoading={mappingsQuery.isLoading}
        />
      ))}
    </>
  )
}
